import {toast} from 'react-toastify';
import {addProductToDestination} from './addToDestination';
import {IDraggedProduct} from './productDrag';
import {INormalizedProduct} from '../models/NormalizedProduct';

/**
 * Adds a set of products to a bundle with one loading toast that resolves to a count. Shared by every
 * surface that hands products to a bundle: a drop on a bundle card or on the docked editor, and the
 * "Add selected" commands. Products without a catalog cannot be added and are skipped.
 */
export const addProductsToBundle = async (
    dispatch: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    bundleId: string,
    bundleName: string | undefined,
    products: IDraggedProduct[],
): Promise<{added: number, failed: number}> => {
    const wanted = products.filter((p) => p.id && p.catalog);
    const target = bundleName ?? 'the bundle';
    if (wanted.length === 0) {
        toast.info(`Nothing to add to ${target}`);
        return {added: 0, failed: 0};
    }
    const what = wanted.length === 1 ? (wanted[0].name ?? 'product') : `${wanted.length} products`;
    const toastId = toast.loading(`Adding ${what} to ${target}…`);
    let added = 0;
    for (const ref of wanted) {
        try {
            if (await addProductToDestination(dispatch, {type: 'bundle', id: bundleId, name: bundleName}, {id: ref.id, catalog: ref.catalog} as INormalizedProduct)) added += 1;
        } catch { /* counted below */ }
    }
    const failed = wanted.length - added;
    toast.update(toastId, {
        type: failed === 0 ? 'success' : added === 0 ? 'error' : 'warning',
        render: failed === 0
            ? `Added ${added === 1 ? (wanted[0].name ?? 'product') : `${added} products`} to ${target}`
            : `Added ${added} of ${wanted.length} to ${target}`,
        isLoading: false,
        autoClose: 3000,
    });
    return {added, failed};
};

export const toDraggedProducts = (products: INormalizedProduct[]): IDraggedProduct[] =>
    products.filter((p) => !!p?.id).map((p) => ({id: p.id, catalog: p.catalog, name: p.name}));
